(function(){"use strict";}());

angular.module("app")
    .directive("completionPreView", ["AppService", function(AppService){

        return {
            restrict: "A",
            replace: false,
            templateUrl: "views/completion-pre.html",
            link: function(scope, element, attributes){
            }
        };

    }]);
